export default __webpack_public_path__ + "static/visa-and-mastercard-13128a225654936d7cc7ae19816b9217.png";